/**
 * Havolani mijozga yuborish — qaysi yuzada ochilganiga qarab.
 *
 *   - Telegram Mini App: `t.me/share/url` — Telegramning o'z chat tanlash
 *     oynasi. `navigator.share` WebView ichida yo'q yoki ishonchsiz.
 *   - Android ilova (TWA) va brauzer: telefonning odatdagi "Ulashish"
 *     oynasi (`navigator.share`) — Telegram, SMS, WhatsApp va boshqalar.
 *   - Ikkalasi ham bo'lmasa (masalan, kompyuter brauzeri) — matn nusxalanadi.
 */
import type { StatementLink } from '../api';
import { isTelegram } from './surface';

export type ShareOutcome = 'shared' | 'copied' | 'cancelled';

export async function shareLink(link: StatementLink): Promise<ShareOutcome> {
  const tg = window.Telegram?.WebApp;
  if (isTelegram() && tg?.openTelegramLink) {
    const params = new URLSearchParams({ url: link.url, text: link.message });
    tg.openTelegramLink(`https://t.me/share/url?${params.toString()}`);
    return 'shared';
  }

  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ text: link.text });
      return 'shared';
    } catch (err: any) {
      if (err?.name === 'AbortError') return 'cancelled';
      // NotAllowedError: so'rov uzoq cho'zilib, bosish ishorasi "sovib"
      // qoldi — nusxalashga o'tamiz, foydalanuvchi qo'lda yuboradi.
    }
  }

  await navigator.clipboard.writeText(link.text);
  return 'copied';
}
